import { getApp } from 'firebase/app'
import {
  getAnalytics,
  isSupported,
  logEvent,
  settings,
  setConsent
} from 'firebase/analytics'

settings({
  gtagName: 'firebaseGtag',
  dataLayerName: 'firebaseDataLayer'
})

let analyticsInstance = null

export const trackFirebaseEvent = async (eventName, eventParams = {}) => {
  try {
    if (!(await isSupported())) return

    if (!analyticsInstance) {
      analyticsInstance = getAnalytics(getApp())
      setConsent({
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      })
    }

    logEvent(analyticsInstance, eventName, eventParams)
  } catch (err) {
    console.warn('trackFirebaseEvent failed:', err)
  }
}
